import styled from 'styled-components';

const NumberedListStyled = styled.ul`
  list-style: none;

  li {
    counter-increment: listIndex;
    margin-bottom: 16px;
    display: flex;

    &:before {
      content: counter(listIndex);
      display: flex;
      justify-content: center;
      align-items: flex-end;
      width: 24px;
      height: 24px;
      line-height: 24px;
      flex: 0 0 24px;
      margin-right: ${({ theme }) => theme.spacing.km4};
      border: 1px solid ${({ theme }) => theme.color.border.brand.default};
      border-radius: ${({ theme }) => theme.border.radius.circle};
      color: ${({ theme }) => theme.color.border.brand.default};
      font-size: ${({ theme }) => theme.font.size.m3};
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export default NumberedListStyled;
